// TAS-357: a question step whose session_questions_v2 row does not exist.
//
// Session 1992 had 12 question steps in flow_steps and zero rows in
// session_questions_v2. Game.jsx treated "no question yet" as "still loading"
// and six players sat on a blank cream page for fifteen minutes with nothing
// reported. The two states are told apart here: a row is MISSING only once the
// questions query has resolved without error and there is still no row for
// (wine, round). While the query is in flight, or after it failed, it is not
// missing, it is loading, and the loader stays up.
import * as Sentry from '@sentry/react';

export function isQuestionRowMissing({ currentStep, currentQuestion, questionsLoaded }) {
  if (!questionsLoaded) return false;
  if (currentStep?.type !== 'question') return false;
  return !currentQuestion;
}

// One event per session per page load. Every player in the room hits this at
// the same moment; a fixed fingerprint groups their events into one issue.
const reportedSessions = new Set();

export function reportMissingQuestionOnce({ sessionCode, stepIndex, wineId }) {
  const key = sessionCode == null ? '' : String(sessionCode);
  if (!key || reportedSessions.has(key)) return false;
  reportedSessions.add(key);
  Sentry.captureMessage('Question step has no session_questions_v2 row', {
    level: 'error',
    tags: {
      session_id: key,
      step_index: String(stepIndex ?? ''),
      wine_id: String(wineId ?? ''),
    },
    fingerprint: ['missing-session-questions', key],
  });
  return true;
}

export function __resetMissingQuestionReportsForTests() {
  reportedSessions.clear();
}
